import React from "react";

const initialValue: any = {
  catalogues: {},
};

const AppContext = React.createContext(initialValue);

export default AppContext;
